export default __webpack_public_path__ + "static/media/ico_cancel_line.668b7239.svg";